import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not found in environment variables");
    return;
  }

  if (import.meta.env.NODE_ENV === "production") {
    // Remove the production check to allow testing in development
    Sentry.init({
      dsn,
      // Performance Monitoring
      tracesSampleRate: 0.3,
      environment: import.meta.env.NODE_ENV,
      // Enable debug mode in development
      debug: import.meta.env.NODE_ENV === "development",
      // Enable more verbose logging in development
      enabled: true,
    });
  }
}
